module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-6.22f581fb.jpg";